export const MandateFeesPeriodKeys = ['monthly', 'quarterly', 'yearly', 'custom'] as const;

export type MandateFeesPeriod = typeof MandateFeesPeriodKeys[number];

export type MandateFeesSortKey = 'mandateName' | 'investedAmount' | 'percentage' | 'feesAmount';

export interface MandateFeesRowResponseApi {
  mandate_name: string;
  invested_amount: number;
  percentage: number;
  fees_amount: number;
}

export interface MandateFeesRowResponse {
  mandateName: string;
  investedAmount: number;
  percentage: number;
  feesAmount: number;
}
